/* SwarnHouse text fixups + mobile search enhancements:
   - phone menu names match the desktop menu (WALL ART, OTHER DECOR)
   - one support email everywhere (swarnhouse@gmail.com)
   - popular search chips inside the mobile search panel */
(function () {
  if (window.__shFixups) return;
  window.__shFixups = true;

  var NAME_MAP = { 'WALL DECOR': 'WALL ART', 'TABLE DECOR': 'OTHER DECOR' };
  var OLD_EMAIL = 'houseswarn@gmail.com';
  var NEW_EMAIL = 'swarnhouse@gmail.com';
  var POPULAR = ['Buddha', 'Ganesha', 'Water Fountain', 'Wall Art', 'Krishna', 'Shrinath Ji'];
  var MENU_SCOPES = '.t4s-drawer, [id*="menu-drawer"], [id*="mb_nav"], [id*="mb-nav"], [class*="mb-nav"], [class*="mb_nav"], [class*="menu-mb"], [class*="mb__menu"]';

  function renameMenu() {
    var scopes = document.querySelectorAll(MENU_SCOPES);
    Array.prototype.forEach.call(scopes, function (scope) {
      if (scope.id === 't4s-search-hidden') return;
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue.trim();
        if (NAME_MAP[t]) node.nodeValue = node.nodeValue.replace(t, NAME_MAP[t]);
      }
    });
  }

  function fixEmail() {
    var links = document.querySelectorAll('a[href*="' + OLD_EMAIL + '"]');
    Array.prototype.forEach.call(links, function (a) {
      a.setAttribute('href', a.getAttribute('href').replace(OLD_EMAIL, NEW_EMAIL));
      if (a.textContent.indexOf(OLD_EMAIL) > -1) a.textContent = a.textContent.replace(OLD_EMAIL, NEW_EMAIL);
    });
  }

  function enhanceSearchPanel() {
    var panel = document.getElementById('t4s-search-hidden');
    if (!panel) return;
    var form = panel.querySelector('.t4s-mini-search__frm');
    var btns = panel.querySelector('.t4s-mini-search__btns');
    var input = panel.querySelector('.t4s-mini-search__input');
    if (!form || !btns || !input) return;
    if (input.getAttribute('data-sh-ph') !== '1') {
      input.setAttribute('placeholder', 'Search Buddha, Ganesha, fountains\u2026');
      input.setAttribute('data-sh-ph', '1');
    }
    if (form.querySelector('.sh-msearch-chips')) return;
    var wrap = document.createElement('div');
    wrap.className = 'sh-msearch-chips';
    wrap.innerHTML = '<span class="sh-msearch-chips__label">Popular searches</span><div class="sh-msearch-chips__list"></div>';
    var list = wrap.querySelector('.sh-msearch-chips__list');
    POPULAR.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sh-msearch-chip';
      b.textContent = q;
      b.addEventListener('click', function () {
        input.value = q;
        input.focus();
        ['input', 'keyup', 'change'].forEach(function (ev) {
          input.dispatchEvent(new Event(ev, { bubbles: true }));
        });
      });
      list.appendChild(b);
    });
    btns.parentNode.insertBefore(wrap, btns.nextSibling);
  }

  function run() { try { renameMenu(); fixEmail(); enhanceSearchPanel(); } catch (e) {} }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 200);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
